<template>
  <div class="home-wrap">
    <div class="layout-header-wrap">
      <HeaderOperation></HeaderOperation>
      <HeaderMenu />
    </div>
    <div class="body-wrap">
      <router-view></router-view>
      <FooterInfo></FooterInfo>
    </div>
</div>
</template>

<script>
import HeaderMenu from './components/HeaderMenu.vue'
import HeaderOperation from './components/HeaderOperation.vue'
import FooterInfo from '@/components/FooterInfo/index'
import { SELECTED_LIST } from './configs/demo'

export default {
  components: {
    HeaderMenu,
    HeaderOperation,
    FooterInfo
  },
  data() {
    return {
      checkboxOptions: SELECTED_LIST
    }
  },
  methods: {
    // params
    listenChacked() {
      // console.log(params)
    }
  }
}
</script>
